// import { bgGradient } from "../plugins/bgGradient";
import { columnHighlight } from "../plugins/columnHighlight";
import { selected } from "../plugins/selected";
import { globalColor, colorByIdx } from "../plugins/globalColor";

export function createSeriesFromLabels(labels, opts = {}) {
  return Object.values(labels).map((label, idx) => ({
    label: label,
    show: true,
    spanGaps: true,
    stroke: colorByIdx(labels, idx),
    width: 4,
    ...opts,
  }));
}

// TODO pass this down
function getYAxisLabel(labels) {
  // Get the key of the first label to determine chart type
  const labelKey = Object.keys(labels)[0] || "";

  if (!labelKey || !labels[labelKey]) return "Count";

  // Use the label to determine appropriate y-axis label
  if (labels[labelKey].includes("Peak Concurrent")) {
    return "Concurrent Sessions";
  } else if (labels[labelKey].includes("Unique Users")) {
    return "Active Users";
  } else {
    return "Sessions";
  }
}

export function usage({
  labels,
  onSelectedIndex,
  scale_y_min,
  scale_y_max,
  scale_y_max_lower_bound,
  axis_y_integers_only,
}) {
  // Use passed scale values if provided, otherwise fallback to computed values
  const min = scale_y_min !== undefined ? scale_y_min : 0;

  // For y-axis max, if scale_y_max_lower_bound is provided, we'll use it as a minimum bound for y_max
  let max = scale_y_max !== undefined ? scale_y_max : null;

  return {
    plugins: [
      globalColor({ labels }),
      columnHighlight({
        style: { backgroundColor: "rgba(204,204,204,0.8)" },
      }),
      selected({ onSelectedIndex }),
    ],
    width: 800,
    height: 400,
    padding: [40, 20, 40, 60],
    scales: {
      x: {
        time: true,
        timeZone: "local",
      },
      y: {
        auto: max === null,
        range: (u, min0, max0) => {
          // If scale_y_max_lower_bound is provided, make sure the upper bound is at least that value
          if (scale_y_max_lower_bound !== null && max0 < scale_y_max_lower_bound) {
            return [min, scale_y_max_lower_bound];
          }
          return [min, max0];
        },
      },
    },
    axes: [
      {
        scale: "x",
        label: "Date",
        labelSize: 14,
        grid: { show: true },
        ticks: { show: true },
        timeFormat: "%b %d",
      },
      {
        scale: "y",
        label: getYAxisLabel(labels),
        labelSize: 14,
        grid: { show: true },
        ticks: { show: true },
        values: axis_y_integers_only ? (u, vals) => vals.map((v) => (v % 1 ? null : v)) : undefined,
      },
    ],
    series: [
      {
        // x-values (dates)
        show: true,
        scale: "x",
      },
      ...createSeriesFromLabels(labels, {
        points: {
          show: true,
          size: 5,
        },
      }),
    ],
    legend: {
      show: true,
    },
    hooks: {
      setUnit(uplot) {
        // Enable auto scaling
        uplot.setScale("y", { min: 0, max: null });
      },

      setData(_uplot) {
        // called when data has changed
      },
    },
  };
}
